import Cookies from 'js-cookie';
import debounce from '../Lib/Debounce.js';

const options = {
  shiftpoint: 992,
  breakpoint: {
    pc: 1200,
    tb: 992,
    sp: 768,
    ss: 576,
    min: 390,
  },
  headId: 'js-header',
  footId: 'js-footer',
}

const classList = {
  load: 'is-load',
  loaded: 'is-loaded',
  act: 'is-act',
  inact: 'is-inact',
  actView: 'is-view',
  actOpen: 'is-open',
  actAnime: 'is-anime',
  hidden: 'is-hidden',
  modalOpen: 'modal-open',
  ios: 'is-ios',
  sp: 'is-sp',
  tb: 'is-tb',
  pc: 'is-pc',
  touch: 'is-touch',
}


const status = {
  visited: Cookies.get('visited') ? true : false,
  domain: document.domain,
  page: document.body.getAttribute('data-page'),
  url: document.URL,
  winWidth: window.innerWidth,
  winHeight: window.innerHeight,
  preWidth: window.innerWidth,
  docWidth: document.body.clientWidth,
  docHeight: document.body.clientHeight,
  scrollY: window.pageYOffset,
  scrollCurrent: 0,
  scrollRate: 0,
  viewport: document.querySelector('meta[name="viewport"]').getAttribute('content'),
  ua: navigator.userAgent.toLowerCase(),
  entry: performance.getEntriesByType("navigation")[0].type,
  referrer: document.referrer ? new URL(document.referrer) : null,
  isDesktop     : true,
  isTablet      : false,
  isMobile      : false,
  isFirst       : true,
  isIos         : false,
  isLocal       : false,
  isStage       : false,
  assets        : document.getElementById('js-scripts').src.slice(0,document.getElementById('js-scripts').src.indexOf('assets/')-1),
  wp            : null,
  animationFrame: null,
}

const event = {
  init: () => {
    const widthchange = event.widthchange(200);
    return () => {
      widthchange();
    }
  },
  widthchange: (delay = 200) => {
    let last = window.innerWidth;
    const handler = () => {
      const current = window.innerWidth;
      if (current !== last) {
        const event = new CustomEvent('widthchange', {
          prev: last,
          current: current,
        });
        window.dispatchEvent(event);
        last = current;
      }
    }
    const debouncedHandler = debounce(handler, delay);
    window.addEventListener('resize', debouncedHandler);
    return () => {
      window.removeEventListener('resize', debouncedHandler);
    }
  }
}


export {
  options,
  classList,
  status,
  event,
}